import React from "react";
import { ReactComponent as Abstract } from "assets/img/vectors/homepage/abstract-2.svg";


const Abstract2 = () => (
    <Abstract />
)

export default Abstract2;